import React, { useState } from 'react';
import i18next from 'core/i18n';
import { SmallTitle, palettes } from '@indigo-ag/component-module';

import {
  PhaseSection,
  PhaseSectionProps
} from 'features/brazil-grower/components/BrazilGrowerFinance/shared/PhaseSection';
import {
  FinancialInformationModal,
  FinancialInformationModalProps
} from './components/FinancialinformationModal/FinancialInformationModal';
import { SingleRow } from 'features/brazil-grower/components/BrazilGrowerFinance/shared/SingleRow';
import { createStylesHook, IFinancialInformation } from 'shared';

export interface FinancialInformationSectionProps
  extends Pick<PhaseSectionProps, 'disabled'>,
    Pick<FinancialInformationModalProps, 'updateCredit'> {
  financialInformationInfo?: IFinancialInformation;
}

const useStyles = createStylesHook({
  financialInfoTitle: {
    color: palettes.neutral[700],
    marginBottom: '24px !important'
  },
  commercialInfoTitle: {
    marginTop: '45px !important'
  }
});

interface FinancialInformationSectionSummaryProps
  extends Pick<FinancialInformationSectionProps, 'financialInformationInfo'> {}

export const FinancialInformationSectionSummary: React.FunctionComponent<FinancialInformationSectionSummaryProps> = ({
  financialInformationInfo
}) => {
  /**
   * Styles
   */
  const classes = useStyles();

  return financialInformationInfo ? (
    <div className="width-100">
      <SmallTitle className={classes.financialInfoTitle}>{i18next.t('financialRestrictions')}</SmallTitle>
      <SingleRow title={i18next.t('financialPending')} content={financialInformationInfo?.financialPendency || '-'} />
      <SmallTitle className={`${classes.financialInfoTitle} ${classes.commercialInfoTitle}`}>
        {i18next.t('commercialInformation')}
      </SmallTitle>
      <SingleRow title={i18next.t('debtSituation')} content={financialInformationInfo?.debtSituation || '-'} />
      <br />
      <SingleRow title={i18next.t('moreInformation')} content={financialInformationInfo?.financialInformation || '-'} />
    </div>
  ) : null;
};

export const FinancialInformationSection: React.FunctionComponent<FinancialInformationSectionProps> = ({
  financialInformationInfo,
  updateCredit,
  children,
  ...phaseSectionProps
}) => {
  /**
   * State
   */
  const [modalOpen, setModalOpen] = useState(false);

  const openFinancialInformationModal = (): void => setModalOpen(true);

  const closeFinancialinformationModal = (): void => setModalOpen(false);

  return (
    <>
      <PhaseSection
        {...phaseSectionProps}
        open={!!financialInformationInfo}
        onClickEdit={openFinancialInformationModal}
        title={i18next.t('financialInformation')}
        renderSeparatorBefore
      >
        <FinancialInformationSectionSummary financialInformationInfo={financialInformationInfo} />
      </PhaseSection>
      <FinancialInformationModal
        open={modalOpen}
        closeModal={closeFinancialinformationModal}
        financialInformationInfo={financialInformationInfo}
        updateCredit={updateCredit}
      />
    </>
  );
};
